import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { WarningHintIcon } from 'src/components/HTKit/Messages';
import { ModalV2 } from 'src/components/HTKit/Modals/ModalV2';
import Button, { THEMES } from 'src/components/HTKit/Forms/Button';
import { isEVHint, EV_MODALS } from 'src/containers/EV/SkuQuestionsPage/utils';

const HintComponent = ({ warning }) => {
  if (isEVHint(warning)) {
    return (
      <p className="text-link caption underline whiteSpaceNoWrap">
        {EV_MODALS[warning].hintText}
      </p>
    );
  }
  return <WarningHintIcon content={warning} />;
};

HintComponent.propTypes = {
  warning: PropTypes.string,
};

const EVModal = ({ modalType, hideModal }) => {
  if (!modalType) return null;

  const modalData = EV_MODALS[modalType];

  return (
    <ModalV2
      header={modalData.header}
      isVisible={!!modalType}
      hide={hideModal}
      footerElement1={<></>}
      footerElement3={
        <Button theme={THEMES.V2PRIMARY} onClick={hideModal}>
          Got it
        </Button>
      }
    >
      <img className="width100 marginY-small2" src={modalData.img} />
      <p className="p1">{modalData.body}</p>
    </ModalV2>
  );
};

EVModal.propTypes = {
  warning: PropTypes.string,
  modalType: PropTypes.string,
  hideModal: PropTypes.func,
};

const PreQuestionLabelWithHint = ({ label, warning, inlineIcon }) => {
  // Values are the hint "keys". Based on the key, we can determine what modal to show.
  const [modalType, setModalType] = useState(null);

  const onWarningClick = (e) => {
    if (e) e.preventDefault();
    if (isEVHint(warning)) {
      setModalType(warning);
    }
  };

  const hideModal = () => setModalType(null);

  const containerStyles = cn({
    'flex justifyContentSpaceBetween alignItemsFlexEnd': !inlineIcon,
  });

  return (
    <div className={containerStyles}>
      <span>{label}</span>
      <button onClick={onWarningClick} type="button" className="plainButton marginLeft-tiny">
        <HintComponent warning={warning} />
      </button>
      <EVModal warning={warning} modalType={modalType} hideModal={hideModal} />
    </div>
  );
};

PreQuestionLabelWithHint.propTypes = {
  label: PropTypes.string,
  warning: PropTypes.string,
  inlineIcon: PropTypes.bool, // Display icon inline with the text flow
};

export default memo(PreQuestionLabelWithHint);
